var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "main",
    { staticClass: "col content-spacing", attrs: { role: "main" } },
    [
      _c(
        "div",
        {
          staticClass:
            "d-flex justify-content-between align-items-start pt-3 pb-2 mb-3 border-bottom"
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mb-3 mr-3 flex-grow-1" },
            [
              _c(
                "b-form-select",
                {
                  on: { change: _vm.search },
                  model: {
                    value: _vm.viewData.profile,
                    callback: function($$v) {
                      _vm.$set(_vm.viewData, "profile", $$v)
                    },
                    expression: "viewData.profile"
                  }
                },
                [
                  _c("option", { attrs: { value: "" } }, [
                    _vm._v("Todos os perfis")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "consumer" } }, [
                    _vm._v("Consumidor")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "trader" } }, [
                    _vm._v("Trader")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "investor" } }, [
                    _vm._v("Investidor")
                  ]),
                  _vm._v(" "),
                  _c("option", { attrs: { value: "partner" } }, [
                    _vm._v("Parceiro")
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "mr-3 flex-grow-1" },
            [
              _c("b-form-input", {
                attrs: {
                  autofocus: "",
                  placeholder: "Digite um termo e pressione enter para buscar"
                },
                on: {
                  keyup: function($event) {
                    if (
                      !$event.type.indexOf("key") &&
                      _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                    )
                      return null
                    return _vm.search.apply(null, arguments)
                  }
                },
                model: {
                  value: _vm.viewData.search,
                  callback: function($$v) {
                    _vm.$set(_vm.viewData, "search", $$v)
                  },
                  expression: "viewData.search"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "BaseButtonComponent",
            { attrs: { to: "/faq/new", variant: "primary-action" } },
            [_vm._v("\n      Novo\n    ")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.viewData.loading
        ? _c("loading-list")
        : !_vm.viewData.loading && _vm.state.list && _vm.state.list.length > 0
        ? _c(
            "div",
            { staticClass: "d-flex justify-content-between flex-column h-100" },
            [
              _c("v-table", [
                _c("thead", [
                  _c("tr", [
                    _c("td", [_vm._v("Pergunta")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Perfil")]),
                    _vm._v(" "),
                    _c("td", [_vm._v("Categoria")]),
                    _vm._v(" "),
                    _c("td")
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "tbody",
                  _vm._l(_vm.state.list, function(item) {
                    return _c("tr", { key: item.id }, [
                      _c("td", [_vm._v(_vm._s(item.question))]),
                      _vm._v(" "),
                      _c("td", [
                        item.profile === "consumer"
                          ? _c("span", [_vm._v("Consumidor")])
                          : item.profile === "trader"
                          ? _c("span", [_vm._v("Comercializador")])
                          : item.profile === "investor"
                          ? _c("span", [_vm._v("Investidor")])
                          : _c("span", [_vm._v("Parceiro")]),
                        _vm._v(" "),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        item.category === "ECONOMIZE"
                          ? _c("span", [_vm._v("Economize")])
                          : item.category === "COMERCIALIZE"
                          ? _c("span", [_vm._v("Comercialize")])
                          : item.category === "INVISTA"
                          ? _c("span", [_vm._v("Invista")])
                          : item.category === "ENERGIA"
                          ? _c("span", [_vm._v("Energia")])
                          : item.category === "OUTRAS"
                          ? _c("span", [_vm._v("Outras")])
                          : item.category === "VEINS"
                          ? _c("span", [_vm._v("Veins")])
                          : item.category === "LEGISLACAO"
                          ? _c("span", [_vm._v("Legislação")])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span")
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "text-align": "right" } },
                        [
                          _c(
                            "BaseButtonComponent",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              attrs: {
                                to: `/faq/edit/${item.id}`,
                                size: "sm",
                                title: "Editar",
                                variant: "primary-action"
                              }
                            },
                            [
                              _c("b-icon", {
                                attrs: {
                                  icon: "pencil-square",
                                  "aria-hidden": "true"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "BaseButtonComponent",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              attrs: {
                                size: "sm",
                                title: "Excluir",
                                variant: "danger"
                              },
                              on: { click: () => _vm.remove(item) }
                            },
                            [
                              _c("b-icon", {
                                attrs: { icon: "trash", "aria-hidden": "true" }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  }),
                  0
                )
              ]),
              _vm._v(" "),
              _c("b-pagination-nav", {
                staticClass: "mt-3",
                attrs: {
                  "link-gen": _vm.linkGen,
                  "number-of-pages": _vm.state.pageCount,
                  "use-router": ""
                }
              })
            ],
            1
          )
        : !_vm.viewData.loading
        ? _c("empty-list")
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "d-inline-flex flex-grow-2" }, [
      _c("h1", { staticClass: "h2" }, [_vm._v("Perguntas e Respostas")]),
      _vm._v(" "),
      _c("hr", { staticClass: "vertical-bar" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }